import AnalyticsTitle from "../AnalyticsTitle";
import { tt } from "../../../../utils/i18n/i18n";
import { getDisplayNameForGameType } from "../../../../utils/helpers/getDisplayNameForGameType";
import React, { useMemo } from "react";
import AnalyticsData from "../../model/AnalyticsData";
import PieGraph from "../graphs/PieGraph";
import KC_DashboardGiftsTable from "../../../../designsystem/KC_Card/KC_DashboardGiftsTable";
import TitleAndTwoColumns from "../layout/TitleAndTwoColumns";

interface Props {
  data: AnalyticsData | undefined;
}

export default function (props: Props) {
  const hasAtLeastOneRedeem = useMemo(() => {
    let res = false;
    props.data?.giftsPerformance?.forEach((it) => {
      if (it.nRedeemed > 0) {
        res = true;
      }
    });
    return res;
  }, [props.data?.giftsPerformance]);

  if (!props.data?.distributionOfGameTypes?.length) {
    return null;
  }

  return (
    <TitleAndTwoColumns
      title={<></>}
      left={
        <div className="d-flex flex-column st-gap w-100">
          <AnalyticsTitle
            title={tt("analytics_favorite_game_title", {
              game: getDisplayNameForGameType(
                props.data?.distributionOfGameTypes[0]?._id || ""
              )
            })}
          />
          <PieGraph
            title={tt("analytics_game_distribution")}
            distribution={props.data?.distributionOfGameTypes}
            getDisplayNameForLabel={getDisplayNameForGameType}
            suffix={tt("analytics_games_suffix")}
          />
        </div>
      }
      right={
        !!props.data?.giftsPerformance?.length ? (
          <div className="d-flex flex-column st-gap w-100">
            <AnalyticsTitle
              title={
                hasAtLeastOneRedeem
                  ? tt("analytics_favorite_gift_title", {
                      gift: props.data?.giftsPerformance[0]?.name
                    })
                  : tt("analytics_no_redeemed_gift")
              }
            />
            <KC_DashboardGiftsTable
              title={""}
              giftsPerformance={props.data?.giftsPerformance}
            />
          </div>
        ) : null
      }
    />
  );
}
